import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import TrustSection from "./components/TrustSection";
import ComparisonTable from "./components/ComparisonTable";
import ReviewSection from "./components/ReviewSection";
import ArticleCards from "./components/ArticleCards";
import CTASection from "./components/CTASection";
import FAQSection from "./components/FAQSection";

const siteUrl = import.meta.env.VITE_SITE_URL;
const logoSrc = "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <TrustSection />
        <ComparisonTable />
        <ReviewSection />
        <ArticleCards />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />

      {/* WebSite Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "KakobuySpreadsheet",
            "url": `${siteUrl}/`,
            "description": "The most trusted Kakobuy Spreadsheet resource for sneakers, streetwear, and luxury finds with verified seller recommendations and buying guides.",
            "publisher": {
              "@type": "Organization",
              "name": "KakobuySpreadsheet",
              "url": `${siteUrl}/`,
              "logo": logoSrc,
            },
          }),
        }}
      />

      {/* Organization Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "KakobuySpreadsheet",
            "url": `${siteUrl}/`,
            "logo": logoSrc,
            "description": "The most trusted Kakobuy Spreadsheet resource for sneakers, streetwear, and luxury finds with verified seller recommendations and buying guides.",
            "sameAs": [
              "https://kaspreadsheet.com/",
            ],
          }),
        }}
      />
    </>
  );
}